import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { NoResultsComponent } from './no-results.component';

@NgModule({
  declarations: [NoResultsComponent],
  imports: [CommonModule, MatIconModule],
  exports: [NoResultsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NoResultsModule {}
